// Contact Form API Integration
// This utility handles contact form submissions via serverless functions

/**
 * Submit contact form data to the serverless function
 * @param {Object} formData - The form data containing name, email, project, and message
 * @returns {Promise<boolean>} - Returns true if form was submitted successfully
 */
export const submitContactForm = async (formData) => {
  try {
    const apiUrl = "/contact.php";

    const response = await fetch(apiUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    });

    const result = await response.json();

    if (!response.ok) {
      throw new Error(result.error || `HTTP error! status: ${response.status}`);
    }

    console.log("Contact form submitted successfully:", result);
    return true;
  } catch (error) {
    console.error("Error submitting contact form:", error);
    throw error;
  }
};
